module.exports = __webpack_public_path__ + "img/west-vvip-gal-1.58d63d17.jpg";